import React from "react";

import { faExternalLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Container, Image, Row } from "react-bootstrap";

import SectionHeader from "@/components/SectionHeader.component";

import i18n from "../../i18n";

const TvComponent = (): React.JSX.Element => {
  const { t } = i18n;

  const items = [
    {
      img: "https://cdn.pakville.ca/images/events/2025_Dragons_Den/02 - thumbnail.jpg",
      videoLink: "https://youtube.com/shorts/nJzCIYhc1TM?si=RnVDoHW9Y_5kdAOc",
      title: t("Dragons’ Den Canada"),
      description: t(
        "PakVille takes the national stage to share its vision for faster, greener and more affordable housing.",
      ),
    },

    {
      img: "https://cdn.pakville.ca/images/events/2025_Dans_l_oeil_du_dragon/3_thumbnail_dragon.png",
      title: t("Dans l’œil du dragon"),
      description: t(
        "PakVille presents its sustainable construction technology to Québec's Dragons.",
      ),
    },
  ];

  return (
    <Container>
      <SectionHeader
        eyebrow={t("Featured Television")}
        title={t("PakVille Faces the Dragons")}
        description={t(
          "PakVille presented its vision for the future of housing on both Canada's English- and French-language versions of the Dragons' Den format.",
        )}
      />
      <Row>
        {items.map((item, index: number) => (
          <Col key={index} className="mb-4" sm={6}>
            <Card className="d-flex align-items-center justify-content-center h-100 shadow flex-column rounded">
              <Card.Img
                alt={item.title}
                className="modelCardImg"
                loading="lazy"
                src={item.img}
                variant="top"
              />

              <Card.Body
                className="h-100 p-3 d-flex align-items-start flex-column rounded-end"
                style={{ backgroundColor: "#FFFFFF" }}
              >
                <Card.Title
                  className="fs-4 mt-3 mb-3"
                  style={{ color: "var(--primary-color)" }}
                >
                  {item.title}
                </Card.Title>

                <Card.Text className="mb-4">{item.description}</Card.Text>
              </Card.Body>

              {item.videoLink ? (
                <Card.Footer
                  className="d-flex align-items-center justify-content-between w-100 flex-wrap"
                  style={{
                    background: "#FFF",
                    border: "none",
                  }}
                >
                  <a
                    className=" w-100"
                    href={item.videoLink}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <Button className="btn-primary border-0 w-100" size="sm">
                      {t("What the full pitch")}
                      <FontAwesomeIcon className="ms-2" icon={faExternalLink} />
                    </Button>
                  </a>
                </Card.Footer>
              ) : null}
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default TvComponent;
